import { additionalScoreWeight, sortHelper } from "../helpers";
var ScoreboardPropsFunction = function (x) {
    var team1 = "1";
    var team2 = "2";
    var filterTeam = function (position) {
        return Object.keys(x.score.additionalScores)
            .filter(function (scoreKey) { return scoreKey[scoreKey.length - 1] === position; })
            .filter(function (x) { return Object.keys(additionalScoreWeight).some(function (y) { return x.toLowerCase().indexOf(y) > -1; }); })
            .filter(function (scoreKey) {
            var oppositePos = position === team1 ? team2 : team1;
            var scoreKeyOpposite = "" + scoreKey.slice(0, scoreKey.length - 1) + oppositePos;
            return x.score.additionalScores[scoreKey] !== "0" || x.score.additionalScores[scoreKeyOpposite] !== "0";
        })
            .sort(function (x, y) { return sortHelper(x) - sortHelper(y); })
            .map(function (value) { return x.score.additionalScores[value]; });
    };
    var props = function (first, second) {
        return {
            team1: filterTeam(first),
            team2: filterTeam(second),
            endingPoint1: x.score.additionalScores["currentGameScore" + first],
            endingPoint2: x.score.additionalScores["currentGameScore" + second]
        };
    };
    if (x.isTeamSwap) {
        return props(team2, team1);
    }
    return props(team1, team2);
};
export var Scoreboards = {
    Tennis: ScoreboardPropsFunction,
    Volleyball: ScoreboardPropsFunction,
    BeachVolleyball: ScoreboardPropsFunction,
    Empty: function () {
        return {
            team1: [],
            team2: [],
            endingPoint1: "",
            endingPoint2: ""
        };
    }
};
//# sourceMappingURL=Scoreboards.js.map